var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 71,
    viewBox: "0 0 95 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_216_1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 45.9488L88.5753 9.79709L21.8557 63.4902C18.526 66.2159 10.6696 69.6278 5.88164 61.4698C1.0937 53.3119 7.2286 47.7233 10.8945 45.9488Z",
    fill: "#040507"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_1727)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_216_1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 45.9488L88.5753 9.79709L21.8557 63.4902C18.526 66.2159 10.6696 69.6278 5.88164 61.4698C1.0937 53.3119 7.2286 47.7233 10.8945 45.9488Z",
    fill: "#595959"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_216_1727",
    x: 4.1268,
    y: 9.79688,
    width: 84.4485,
    height: 59.4078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.62655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31327
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_216_1727"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_216_1727",
    x: 4.1268,
    y: 9.79688,
    width: 84.4485,
    height: 59.4078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.62655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31327
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_216_1727"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_1727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1628,
    height: 97.8389,
    fill: "white",
    transform: "translate(82.9721 0.830078) rotate(58)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedle);
export default __webpack_public_path__ + "static/media/needle.f9405c0e5d2c797f9a841e067a1984a9.svg";
export { ForwardRef as ReactComponent };